import React, { useContext } from "react";
import { AuthContext } from "./AuthContextComponent";
import { feversion } from "../lib/config/index";
import { STATUS } from "../lib/enums/index";

interface FooterProps {
  theme?: string;
  beversion?: string;
}

const Footer: React.FC<FooterProps> = ({ beversion }) => {
  const { userInfo, username, internalPartnerName } = useContext(AuthContext);

  const backgroundColor = userInfo?.theme === "DARK" ? "#24292e" : "#DDDDDD";

  return (
    <div
      style={{
        backgroundColor,
      }}
      className={`flex justify-between items-center h-[50px] w-full font-sans transition-colors duration-700 ease-in-out text-custom-petite ${
        userInfo?.theme === `DARK` ? "text-white" : "text-black"
      }  `}
    >
      <div>
        <ul className="flex gap-5 ml-5 transition-colors duration-300 ease-in-out">
          <li>
            <b>Username : </b> {username}
          </li>
        </ul>
      </div>
      {userInfo?.category === STATUS.INTERNAL ? (
        <>
          <div className="pr-8">
            <label>{internalPartnerName}</label>
          </div>
        </>
      ) : (
        " "
      )}
      {userInfo?.category === STATUS.EXTERNAL ? (
        <div>{userInfo.partnersName}</div>
      ) : (
        ""
      )}
      <div className="pr-8">
        <label>
          Version : {feversion}.{beversion}
        </label>
      </div>
    </div>
  );
};

export default Footer;
